// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"toggle-button_toggleButton__1pv7j","active":"toggle-button_active__322wi"};